var path = 'public/app/features/dashboard/partials/folder_dashboards.html';
var html = "<page-header ng-if=ctrl.navModel model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n    <manage-dashboards ng-if=\"ctrl.folderId && ctrl.uid\" folder-id=ctrl.folderId folder-uid=ctrl.uid />\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/features/dashboard/partials/folder_dashboards.html
// module id = 806
// module chunks = 2